import ContestDetail from '@/apps/ContestDetail'
import Layout from '@/apps/layout/components'
import React from 'react'

const ContestDetailPage = (): React.ReactElement => {
  return (
    <Layout>
      <ContestDetail />
    </Layout>
  )
}

export default ContestDetailPage
